<template>
  <div class="article"
       v-loading.fullscreen.lock="fullscreenLoading">
    <div class="article_top">
      <div class="article_top_left"
           v-if="ar_type!=11">
        <el-upload class="avatar-uploader"
                   :action="upUrl"
                   :show-file-list="false"
                   :on-success="handleAvatarSuccess"
                   :before-upload="beforeAvatarUpload">
          <img v-if="imageUrl"
               :src="imageUrl"
               class="avatar">
          <i v-else
             class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="article_top_right">
        <div class="right_top">
          <span class="article_title_text">文章标题：</span>
          <el-input v-model="article_title"
                    placeholder="请输入文章标题"></el-input>
        </div>
        <div class="right_bottom"
             v-if="ar_type!=8&&ar_type!=11">
          <span class="article_title_text">文章描述：</span>
          <el-input v-model="article_describe"
                    type="textarea"
                    :rows="6"
                    resize='none'
                    placeholder="请输入文章的简短描述"></el-input>
        </div>
      </div>
    </div>
    <div class="article_bottom">

      <quill-editor v-model="content"
                    class="ql-editor"
                    :options="editorOption"
                    ref="myQuillEditor"> </quill-editor>
      <form action
            method="post"
            enctype="multipart/form-data"
            id="uploadFormMulti">
        <input style="display: none"
               :id="uniqueId"
               type="file"
               name="file"
               multiple
               accept="image/jpg, image/jpeg, image/png, image/gif"
               @change="uploadImg('uploadFormMulti')" />
      </form>
    </div>

    <el-button type="primary"
               class="floatBtn"
               @click="addArticle">
      保存
    </el-button>
  </div>
</template>
<script>
// import Quill from "quill";
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from "quill-image-super-solution-module";
import ImageResize from "quill-image-resize-module"; // 引用
// import { ImageDrop } from "quill-image-drop-module";
// Quill.register("modules/imageDrop", ImageDrop);
Quill.register('modules/ImageExtend', ImageExtend)
Quill.register("modules/imageResize", ImageResize); // 注册
import axios from 'axios';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { apiDelete, apiArticle, apiGetArticle } from '@/request/api'
import store from '@/store/index'

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  [{ align: [] }], // 对齐方式-----[{ align: [] }]
  ["clean"], // 清除文本格式-----['clean']
  ["image",] // 链接、图片、视频-----['link', 'image', 'video']
];

export default {
  components: {
    quillEditor
  },
  data () {
    return {
      editorOption: {
        example: "test",
        theme: "snow",
        placeholder: "请输入正文",
        modules: {
          ImageExtend: {
            name: 'file',
            size: 2,
            action: store.state.upUrl,
            accept: "image/jpg, image/png, image/gif, image/jpeg, image/bmp, image/x-icon",
            headers: (xhr) => {
            },
            response: (res) => {
              return res.url
            },
            sizeError: () => {
              alert("图片大小超过 2 M");
            },
            start: () => { },
            // 可选参数 自定义上传结束触发的事件，无论成功或者失败
            // Optional parameters. Customize the event triggered by the end of upload, regardless of success or failure
            end: () => { },
            // 可选参数 上传失败触发的事件
            // Optional parameter. The event triggered by upload failure
            error: () => { },
            // 可选参数  上传成功触发的事件
            // Optional parameter. The event triggered by a successful upload
            success: () => { },
          },
          imageResize: {
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white"
            },
            modules: ["Resize", "DisplaySize", "Toolbar"]
          },
          //  富文本编辑器配置
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function () {
                QuillWatch.emit(this.quill.id)
              }
            }
          }
        }
      },
      //callback值
      callback: '',
      //封装的上传url路径
      upUrl: '',
      //页面加载
      fullscreenLoading: false,
      //类型
      ar_type: '',
      //id
      tid: '',
      //网址id
      siteid: '',
      //上级id
      cid: '',
      //文章描述
      article_describe: '',
      //封面id
      logoID: '',
      //封面图片
      imageUrl: '',
      //文章标题
      article_title: '',

      uniqueId: "uniqueId",
      content: "", // 富文本编辑器默认内容

    };
  },
  computed: {
    //当前富文本实例
    editor () {
      return this.$refs.myQuillEditor.quill;
    }
  },
  methods: {
    //读取数据
    async read_article_data () {
      let res = await apiGetArticle({
        siteid: this.siteid,
        id: this.tid
      })
      if (res.errno == 0) {
        this.article_title = res.article[0].title
        this.imageUrl = res.article[0].thumb
        this.article_describe = res.article[0].description
        this.content = res.article[0].content
        this.cid = res.article[0].cid
      } else {
        this.$message.error(res.message)
      }
    },
    //检测数据是否填写完整
    detection_data () {
      if (this.article_title == '') {
        this.$message.error('文章标题不能为空')
        return false
      }
      if (this.imageUrl == '' && this.ar_type != 11) {
        this.$message.error('文章封面图片不能为空')
        return false
      }
      if (this.article_describe == '' && this.ar_type != 8 && this.ar_type != 11) {
        this.$message.error('文章描述不能为空')
        return false
      }
      return true
    },
    //保存文章
    async addArticle () {
      this.fullscreenLoading = false
      if (this.detection_data()) {
        let res = await apiArticle({
          siteid: this.siteid,
          id: this.tid,
          cid: this.cid,
          title: this.article_title,
          description: this.ar_type == 8 || this.ar_type == 11 ? '介绍业务广告文章，不需要描述' : this.article_describe,
          content: this.content,
          thumb: this.imageUrl
        })
        if (res.errno == 0) {
          localStorage.setItem('websitePage_logoID', '')
          this.$message.success(res.message)
          this.$router.go(-1)
        } else {
          this.$message.error(res.message)
        }
        this.fullscreenLoading = false

      }
    },
    //上传成功
    async handleAvatarSuccess (res) {
      if (res.error) {
        return this.$message.error(res.error.message)
      }
      this.imageUrl = res.url
      if (this.logoID != '') {
        let res = await apiDelete({
          type: 'image',
          id: this.logoID
        })
      }
      this.logoID = res.id
      localStorage.setItem('websitePage_logoID', res.id)
    },
    //上传检测
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG / PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传封面图片大小不能超过 1MB!');
      }
      return isJPG && isLt2M;
    },
    // 准备富文本编辑器
    onEditorReady () { },
    // 富文本编辑器 失去焦点事件
    onEditorBlur () { },
    // 富文本编辑器 获得焦点事件
    onEditorFocus () { },
    // 富文本编辑器 内容改变事件
    onEditorChange () { },
    uploadImg: async function () {
      var _this = this;
      //构造formData对象
      var form_data = new FormData();
      form_data.append("file", document.getElementById(_this.uniqueId).files[0]);

      try {
        axios({
          method: 'post',
          url: 'index.php?i=2&c=entry&do=upfile&m=wxl_oms&op=upload',
          data: form_data
        }).then(res => {
          //返回上传文件的地址
          let url = res.data.url;
          if (url != null && url.length > 0) {
            let Range = _this.editor.getSelection();
            url = url.indexOf("http") != -1 ? url : "http:" + url;
            //上传文件成功之后在富文本中回显(显示)
            _this.editor.insertEmbed(
              Range != null ? Range.index : 0,
              "image",
              url
            );
          } else {
            _this.$message.warning("图片上传失败");

          }
          document.getElementById(_this.uniqueId).value = "";
        })

      } catch ({ message: msg }) {
        document.getElementById(_this.uniqueId).value = "";
        _this.$message.warning(msg);
      }
    }
  },
  mounted () {

  },
  created () {
    this.upUrl = this.$store.state.upUrl;
    this.callback = this.$route.query.callback
    if (this.$route.query.siteid == '') {
      this.$message.error('未读取到网址id')
      return this.$router.go(-1)
    }

    this.siteid = this.$route.query.siteid
    this.ar_type = this.$route.query.type
    this.cid = this.$route.query.cid
    this.logoID = localStorage.getItem('websitePage_logoID')
    if (this.$route.query.id) {
      this.tid = this.$route.query.id
      this.read_article_data()
    }

  }
};
</script>
<style lang='scss' >
.article {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  .article_top,
  .article_bottom {
    flex: 1;
  }
  .article_top {
    max-height: 250px;
    display: flex;
    margin-bottom: 10px;
    .article_top_left {
      max-width: 250px;
      background-color: #fff;
      flex: 1;
      .el-upload {
        width: 250px;
        height: 250px;
        box-sizing: border-box;
      }
    }
    .article_top_right {
      flex: 1;
      display: flex;
      flex-direction: column;
      // background-color: pink;

      margin-left: 10px;
      .right_top,
      .right_bottom {
        display: flex;
        flex: 1;
        .article_title_text {
          width: 100px;
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;
        }
      }
      .right_top {
        max-height: 50px;
      }
      .right_bottom {
        margin-top: 20px;
        .el-textarea__inner {
          height: 100%;
        }
      }
    }
  }
  .article_bottom {
    height: 0;
    .quill-editor {
      height: 100%;
      display: flex;
      flex-direction: column;
      border-radius: 4px;
      overflow: hidden;
      .ql-toolbar {
        flex: 1;
        max-height: 42px;
        border-radius: 4px 4px 0 0;
      }
      .ql-container {
        flex: 1;
        overflow: auto;
      }
    }
  }
  .floatBtn {
    position: fixed;
    width: 50px;
    height: 50px;
    bottom: 100px;
    right: 50px;
    padding: 0;
    border-radius: 50px;
  }
}
</style>